import { StripeStatus } from 'src/modules/member/models/member';

export enum StripePeriodicity {
  OneMonth = 1,
  TwoMonths = 2,
  ThreeMonths = 3,
  FourMonths = 4,
  SixMonths = 5,
  TwelveMonths = 6,
}

export const displayStripeStatus = (status: StripeStatus, t: (n: string) => string) => {
  if (status && status.periodicity === StripePeriodicity.OneMonth) {
    return t('member:stripe.month');
  }
  if (status && status.periodicity === StripePeriodicity.TwoMonths) {
    return t('member:stripe.twoMonths');
  }
  if (status && status.periodicity === StripePeriodicity.ThreeMonths) {
    return t('member:stripe.threeMonths');
  }
  if (status && status.periodicity === StripePeriodicity.FourMonths) {
    return t('member:stripe.fourMonths');
  }
  if (status && status.periodicity === StripePeriodicity.SixMonths) {
    return t('member:stripe.sixMonths');
  }
  if (status && status.periodicity === StripePeriodicity.TwelveMonths) {
    return t('member:stripe.year');
  }
  return t('member:noAutogiro');
};

export const displayStripePeriodicityOnly = (status: StripeStatus, t: (n: string) => string) => {
  if (status && status.periodicity === StripePeriodicity.OneMonth) {
    return t('member:stripePeriod.month');
  }
  if (status && status.periodicity === StripePeriodicity.TwoMonths) {
    return t('member:stripePeriod.twoMonths');
  }
  if (status && status.periodicity === StripePeriodicity.ThreeMonths) {
    return t('member:stripePeriod.threeMonths');
  }
  if (status && status.periodicity === StripePeriodicity.FourMonths) {
    return t('member:stripePeriod.fourMonths');
  }
  if (status && status.periodicity === StripePeriodicity.SixMonths) {
    return t('member:stripePeriod.sixMonths');
  }
  if (status && status.periodicity === StripePeriodicity.TwelveMonths) {
    return t('member:stripePeriod.year');
  }
  return t('member:noAutogiro');
};
